import {
  StoryblokComponent,
  storyblokEditable,
  renderRichText,
} from "@storyblok/react";
import { Breadcrumb } from "./Breadcrumb";

const SolutionSingle = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display ">
      <div className="container herosub">
        <Breadcrumb currentName={blok.title} />
        <h1>{blok.title}</h1>
        <h2>{blok.subtitle}</h2>
      </div>

      <div className="font-display text-left integrations-content">
        <div
          className="intro-integrations"
          dangerouslySetInnerHTML={{ __html: renderRichText(blok.introstat) }}
        />

        <div className="card-grid">
          {blok.columns
            ? blok.columns.map((blok) => (
                <StoryblokComponent blok={blok} key={blok._uid} />
              ))
            : null}
        </div>
      </div>
      <div className="form-container">
        <div className="form-pre">
          <h2>Your path to increased revenue starts here</h2>
        </div>
        <div className="form"></div>
        {blok.form
          ? blok.form.map((blok) => (
              <StoryblokComponent blok={blok} key={blok._uid} />
            ))
          : null}
      </div>
    </div>
  );
};

export default SolutionSingle;
